import { useState } from 'react'
import { useAuth } from '../contexts/AuthContext'
import FriendsList from '../components/FriendsList'

export default function Friends() {
  const { isLoggedIn } = useAuth()
  const [searchQuery, setSearchQuery] = useState('')

  if (!isLoggedIn) {
    return (
      <div className="friends-page">
        <div className="container">
          <div className="auth-required">
            <h1>Login Required</h1>
            <p>You must be logged in to view your friends.</p>
            <div className="auth-actions">
              <button className="btn-primary">Login</button>
              <button className="btn-secondary">Sign Up</button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="friends-page">
      <div className="container">
        {/* Friends Header */}
        <div className="friends-header-section">
          <div className="header-content">
            <h1>Friends</h1>
            <p>Manage your friends and discover new community members</p>
          </div>
          
          <div className="header-stats">
            <div className="stat">
              <span className="stat-number">47</span>
              <span className="stat-label">Total Friends</span>
            </div>
            <div className="stat">
              <span className="stat-number">12</span>
              <span className="stat-label">Online Now</span>
            </div>
            <div className="stat">
              <span className="stat-number">3</span>
              <span className="stat-label">New Requests</span>
            </div>
          </div>
        </div>

        {/* Search and Filter */}
        <div className="friends-controls">
          <div className="search-section">
            <input
              type="text"
              placeholder="Search friends..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="friends-search"
            />
            <button className="search-btn">🔍</button>
          </div>
          
          <div className="filter-section">
            <button className="filter-btn active">All Friends</button>
            <button className="filter-btn">Online</button>
            <button className="filter-btn">Recent</button>
            <button className="filter-btn">Requests</button>
          </div>
        </div>

        {/* Friends List */}
        <div className="friends-main">
          <FriendsList 
            maxVisible={20} 
            showHeader={false} 
            compact={false}
          />
        </div>

        {/* Friend Requests Section */}
        <div className="friend-requests-section">
          <h3>Friend Requests</h3>
          <div className="requests-list">
            <div className="request-item">
              <div className="request-avatar">
                <div className="avatar-placeholder">N</div>
              </div>
              <div className="request-info">
                <span className="request-name">NewMember123</span>
                <span className="request-time">2 hours ago</span>
              </div>
              <div className="request-actions">
                <button className="accept-btn">Accept</button>
                <button className="decline-btn">Decline</button>
              </div>
            </div>
            
            <div className="request-item">
              <div className="request-avatar">
                <div className="avatar-placeholder">K</div>
              </div>
              <div className="request-info">
                <span className="request-name">KratomLover</span>
                <span className="request-time">1 day ago</span>
              </div>
              <div className="request-actions">
                <button className="accept-btn">Accept</button>
                <button className="decline-btn">Decline</button>
              </div>
            </div>
          </div>
        </div>

        {/* Suggested Friends */}
        <div className="suggested-friends-section">
          <h3>People You May Know</h3>
          <div className="suggestions-grid">
            <div className="suggestion-item">
              <div className="suggestion-avatar">
                <div className="avatar-placeholder">S</div>
              </div>
              <div className="suggestion-info">
                <span className="suggestion-name">StrainExpert</span>
                <span className="suggestion-mutual">3 mutual friends</span>
              </div>
              <button className="add-friend-btn">Add Friend</button>
            </div>
            
            <div className="suggestion-item">
              <div className="suggestion-avatar">
                <div className="avatar-placeholder">V</div>
              </div>
              <div className="suggestion-info">
                <span className="suggestion-name">VendorReviewer</span>
                <span className="suggestion-mutual">5 mutual friends</span>
              </div>
              <button className="add-friend-btn">Add Friend</button>
            </div>
            
            <div className="suggestion-item">
              <div className="suggestion-avatar">
                <div className="avatar-placeholder">M</div>
              </div>
              <div className="suggestion-info">
                <span className="suggestion-name">ModerateDose</span>
                <span className="suggestion-mutual">2 mutual friends</span>
              </div>
              <button className="add-friend-btn">Add Friend</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}